/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */

import React, {Component} from 'react';

import DocumentTitle from 'react-document-title';
import Translate from '../components/Translate';

import ShowcasePurchases from '../containers/ShowcasePurchases';

class ShowcasePurchasesRoute extends Component {

  render() {

    return (<DocumentTitle title={Translate.translator('page.purchases')}>
      <ShowcasePurchases />
    </DocumentTitle>);
  }
}

export default ShowcasePurchasesRoute;



// WEBPACK FOOTER //
// ./src/routes/purchases-route.js